export const tryGetFirefoxVersion = () => {
  const userAgentFirefoxMatch = navigator.userAgent.match(/Firefox\/(\d+)/);
  if (!userAgentFirefoxMatch || !userAgentFirefoxMatch[1]) {
    return null;
  }

  return parseInt(userAgentFirefoxMatch[1], 10);
};
